module.exports = __webpack_public_path__ + "static/img/scandit.4f1d208.png";